import { template as AAPL } from './AAPL';
import { template as AutoLoan } from './AutoLoan';
import { template as ImpermanentLoss } from './ImpermanentLoss';

const templateMap = {
  'AAPL': AAPL,
  'AutoLoan': AutoLoan,
  'ImpermanentLoss': ImpermanentLoss
};

export { templateMap, AAPL, AutoLoan, ImpermanentLoss };